import React, { useState } from 'react';
import { Dialog } from '../../../../../../components/Dialog';
import { DeletePersonnelDialog } from '../DeletePersonnelDialog';
import { S } from './DeletePersonnelButton.styles';

type Props = {
  personnelId: string;
  /** Compact trash icon for accordion rows */
  iconOnly?: boolean;
};

export const DeletePersonnelButton: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog.Provider isOpen={isOpen}>
      <Dialog.Trigger>
        <S.Trigger
          type="button"
          aria-label="Radera person"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(true);
          }}
        >
          <S.Icon src="Trash" height={22} color="secondary" />
          {!props.iconOnly && <S.H6 color="secondary">Radera</S.H6>}
        </S.Trigger>
      </Dialog.Trigger>

      <DeletePersonnelDialog
        personnelId={props.personnelId}
        onClose={() => setIsOpen(false)}
      />
    </Dialog.Provider>
  );
};
